import { useLocation } from 'react-router-dom';

const NotFoundPage = () => {
  const location = useLocation();

  return (
    <div style={{ padding: '50px', textAlign: 'center', direction: 'rtl' }}>
      <h2>404 - Route Not Found</h2>
      <p><strong>Requested Path:</strong> <code>{location.pathname}</code></p>
      <p><strong>Full URL:</strong> <code>{window.location.href}</code></p>
      <details style={{ marginTop: '20px', textAlign: 'right' }}>
        <summary style={{ cursor: 'pointer', color: '#007237', fontWeight: 'bold' }}>
          Debug Info
        </summary>
        <div style={{ marginTop: '10px', background: '#f5f5f5', padding: '15px', borderRadius: '5px' }}>
          <p><strong>Pathname:</strong> {location.pathname}</p>
          <p><strong>Search:</strong> {location.search || '(none)'}</p>
          <p><strong>Hash:</strong> {location.hash || '(none)'}</p>
          <p><strong>Hostname:</strong> {window.location.hostname}</p>
          <p><strong>Protocol:</strong> {window.location.protocol}</p>
          <p><strong>User Agent:</strong> {navigator.userAgent.substring(0, 100)}...</p>
          <p><strong>React Router Active:</strong> ✅ Yes</p>
        </div>
      </details>
      <button
        onClick={() => window.location.href = '/'}
        style={{
          marginTop: '20px',
          padding: '10px 20px',
          backgroundColor: '#007237',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer'
        }}
      >
        חזור לעמוד הראשי
      </button>
    </div>
  );
};

export default NotFoundPage;
